import clsx from 'clsx';
import { useLocation } from 'react-router';
import { ContactHeader } from './ContactHeader';
import { Navbar } from './Navbar';

export function Header({ contact }: { contact: any }) {
  const location = useLocation();
  return (
    <header className={clsx(location.pathname === '/parents' ? 'bg-white' : 'bg-green-25')}>
      <ContactHeader contact={contact} />
      <Navbar contact={contact} />
    </header>
  );
}
